import { FC } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { useGetAllAssessments } from '@features/assessment';
import { LimitPerPage } from '@libs/constants';
import { Trans } from '@libs/i18n';

import { AssessmentsHome } from './AssessmentsHome';
import { AssessmentsOnboarding } from './AssessmentsOnboarding';

export const Assessments: FC = observer(() => {
  // Check if user has any assessments by fetching with limit 10
  const { data, isLoading } = useGetAllAssessments({ page: 1, limit: LimitPerPage.ONE });

  const hasAssessments = (data?.meta.totalCount ?? 0) > 0;

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50vh',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body1" color="text.secondary">
          <Trans i18nKey="app.assessments.loading" />
        </Typography>
      </Box>
    );
  }

  return hasAssessments ? <AssessmentsHome /> : <AssessmentsOnboarding />;
});
